import { render, staticRenderFns } from "./DomainSetting.vue?vue&type=template&id=055b0e77&scoped=true&"
import script from "./DomainSetting.vue?vue&type=script&lang=js&"
export * from "./DomainSetting.vue?vue&type=script&lang=js&"
import style0 from "./DomainSetting.vue?vue&type=style&index=0&id=055b0e77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055b0e77",
  null
  
)

export default component.exports